export default {
  "content": "<path fill=\"#333\" d=\"M7 14a.996.996 0 01-.708-.293l-6-6a1 1 0 010-1.414l6-6a1 1 0 111.415 1.414L2.413 7l5.294 5.294A1 1 0 017 14z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "8",
    "height": "14",
    "fill": "none",
    "viewBox": "0 0 8 14"
  }
};